import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import refrigeratorIcon from '../images/icons/refrigeratorIcon.png'
import propaneIcon from '../images/icons/propaneIcon.png'
import mattressIcon from '../images/icons/mattressIcon.png';
import monitorIcon from '../images/icons/monitorIcon.png';
import oxygenIcon from '../images/icons/oxygenIcon.png';
import tireIcon from '../images/icons/tireIcon.png';
import truckTireIcon from '../images/icons/truckTireIcon.png';
import ExtraCharge from './ExtraCharge';

const extraCostItems = {

    
    freonApplicances:{
        title: "Freon Appliances",
        price: 60,
        img: refrigeratorIcon,
    },
    oxygenTanks:{
        title: "Oxygen Tanks",
        price: 30,
        img: oxygenIcon,
    },
    propaneTanks: {
        title: "Propane Tanks",
        price: 30,
        img: propaneIcon,
    },
    tires:{
        title: "Tires",
        price: 35,
        img: tireIcon,
    },
    truckTires:{
        title: "Truck Tires",
        price: 50,
        img: truckTireIcon,
    },
    mattresses:{
        title: "Mattresses and Box Springs",
        price: 100,
        img: mattressIcon,
    },monitors:{
        title: "TV's and Computer Monitors",
        price: 50,
        img: monitorIcon,

    }

}
const tonnageFee = 225;

const dumpsterOptions = {
    option1: {
        yd: 10,
        ton: 1,
        basePrice: 450,
        // salePrice: 410,
        discount: 25
    },
    option2: {
        yd: 15,
        ton: 1.5,

        basePrice: 550,
        // salePrice: 510,
        discount: 25

    },
}

//Load inital settings to be 10 yard dumpster
const initialDumpsterOptions = {
    size: dumpsterOptions.option1.yd,
    baseDays: 14,
    price: dumpsterOptions.option1.basePrice,
    threeDayDiscount: 25,
    lateFee: 0, // load page with no fees
    tonnage:dumpsterOptions.option1.ton,
    discount: false,
    numberOfDaysForSalePrice: 3, // Right now
    extraFeePerDay: 25
}

function Estimate() {

    // location for scrolling to the extra cost items
    const location = useLocation();
    useEffect(() => {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, [location]);

    //state to keep track of all quantities of extra priced items
    const [quantities, setQuantities] = useState({});

    useEffect( () => {
        
        //set default dumpster, this cannot be done by using the checked property in the html. It messes witht he state
        document.getElementById("10-1").checked = true;
        const initialState = {};
        for(const prop in extraCostItems){
            initialState[prop] = 0;
        }
        setQuantities(initialState);
        // setTimeout(() => console.log(quantities), 1000)
    }, []);

    //UseEffect
    //this is the total of the extra cost items combined
    const [totalExtra, setTotalExtra] = useState (0);

    //useEffect to update what should be added from the extra items into the itemized section
    const [extraCostRendered, setExtraCostRendered] = useState([]);

    useEffect(() => {
    
        //to overwrite extraCostRendered
        const renderArr = [];
        //iterate over quantities
        for(const prop in quantities){
            const title = extraCostItems[prop].title;
            const qty = quantities[prop];
            const price = extraCostItems[prop].price;
            const cost = price * qty;
            
            if(qty > 0){
                renderArr.push(
                    <div className= "estimate-breakdown-section">
                    <p>{title} (x{qty})</p>
                    <p>${cost}</p>
                </div>
                );
            }

        }
        setExtraCostRendered(renderArr);



    }, [quantities]);


    //handles increments for each individual extra cost item
    const handleIncrement = (property, price) => {
        setTotalExtra( (curr) => curr + price );
        setQuantities( (curr) => {
            return {...curr, [property]: (curr[property] + 1)}
        });
    }
    //handles decrements for each individual extra cost item
    const handleDecrement = (property, price) => {
        setTotalExtra( (curr) => curr - price );
        setQuantities( (curr) => {
            return {...curr, [property]: (curr[property] - 1)}
        });
    }
    //this contains all of the tiles of extra charge items
   const tiles = [];
   for(const prop in extraCostItems){
        
        tiles.push( <ExtraCharge key= {prop} title= {extraCostItems[prop].title} img= {extraCostItems[prop].img} price= {extraCostItems[prop].price} thisProperty= {prop} quantities= {quantities} setQuantities= {setQuantities} setTotalExtra= {setTotalExtra} handleIncrement={handleIncrement} handleDecrement={handleDecrement}/>)
    }
    
    //handle state of the dumpster selected
    const [selectedDumpster, setSelectedDumpster] = useState(dumpsterOptions.option1.yd); //this is set to the default selected option
    const [tonnage, setTonnage] = useState(dumpsterOptions.option1.ton);
    const [basePrice, setBasePrice] = useState(dumpsterOptions.option1.basePrice);
    const [discount, setDiscount] = useState(initialDumpsterOptions.threeDayDiscount);
    // handle state for the number of days the dumpster is needed
    const [daysNeeded, setDaysNeeded] = useState(initialDumpsterOptions.baseDays); //14 is the default
    const [daysCost, setDaysCost] = useState(0);


    // Event Handlers
    
    // Invoked when a new dumpster is selected
    const handleDumpsterChange = ({target}) => {
        const value = JSON.parse(target.value);
        setSelectedDumpster(value.yd);
        setTonnage(value.ton);
        setBasePrice(value.basePrice);
        setDiscount(value.discount);
        console.log(value);
        return;
    }
    // invoked when day's change
    const handleDaysChange = ({target}) => {
        setDaysNeeded(target.value); 
        return;
    }
    //useEffect to update the overage cost for days
    useEffect( () => {
        let cost = 0;
        if(daysNeeded > initialDumpsterOptions.baseDays){
            cost = (daysNeeded - initialDumpsterOptions.baseDays) * initialDumpsterOptions.extraFeePerDay;
            setDaysCost(cost);
        }else{
            setDaysCost(0);
        }
    }, [daysNeeded]);

    //handle state for expected ton overage
    const [tonOver, setTonOver] = useState(0);
    const handleTonnage = ({target}) => {
        setTonOver(target.value);
    };

    console.log(quantities)

    const [totalPrice, setTotalPrice] = useState(dumpsterOptions.option1.basePrice);
    useEffect( () => {

        const tonnageCost = tonOver * tonnageFee;
        if(daysNeeded <= initialDumpsterOptions.numberOfDaysForSalePrice){
            setTotalPrice(basePrice + tonnageCost - discount +  daysCost + totalExtra);
        }else{
            setTotalPrice(basePrice + tonnageCost +  daysCost + totalExtra);
        }

        


    }, [quantities,selectedDumpster, discount, tonOver, daysNeeded, daysCost]); 
  return (
    <div className="body">
        <h1>Estimate Calculator</h1>
        
        <section className= "estimate">
             <h3>Rental Details</h3>
            <section id= "estimate-input">
                <p className= "estimate-input-prompt">Please select a dumpster size / tonnage limit:</p>
                <div id= "estimate-radio-options" className= "input-offset">
                    <div className= "estimate-radio-option">
                        <input  type="radio" id= "10-1" value={JSON.stringify(dumpsterOptions.option1)} onChange= {handleDumpsterChange} name= "dumpster"/>
                        <label htmlFor="10-1">10 Yard with {dumpsterOptions.option1.ton} ton limit</label>
                    </div>
                    <div className= "estimate-radio-option">
                        <input type="radio" id= "15-1" value={JSON.stringify(dumpsterOptions.option2)} onChange= {handleDumpsterChange} name= "dumpster"/>
                        <label htmlFor="15-1">15 Yard with {dumpsterOptions.option2.ton} ton limit</label>

                    </div>
                    {/* <div className= "estimate-radio-option">
                        <input type="radio" id= "15-1.5" value={JSON.stringify({yd: 15, ton: 1.5, basePrice: 495, discount: 55})} onChange= {handleDumpsterChange} name= "dumpster" />
                        <label htmlFor="15-1.5">15 Yard with 1.5 ton limit</label>
                    </div> */}
                </div>
                <p className= "estimate-input-prompt">How long would you like the rental for?</p>
                <div className= "input-offset">
                    <label htmlFor="estimate-days-needed">Days Needed</label>
                    <input id= "estimate-days-needed" onChange= {handleDaysChange} value= {daysNeeded} type="number" min= "1" max= "30"/>
                </div>
                <p className= "estimate-input-prompt">Do you expect to have more than {tonnage} ton?</p>
                <div className= "input-offset">
                    <label htmlFor="">Please select the amount you expect to be over:</label>
                    <select name="ton-overage" id="ton-overage" onChange={handleTonnage}>
                        <option value="0">No overage</option>
                        <option value=".1">.1 ton</option>
                        <option value=".2">.2 ton</option>
                        <option value=".3">.3 ton</option>
                        <option value=".4">.4 ton</option>
                        <option value=".5">.5 ton</option>
                        <option value=".6">.6 ton</option>
                        <option value=".7">.7 ton</option>
                        <option value=".8">.8 ton</option>
                        <option value=".9">.9 ton</option>
                        <option value="1">1 ton</option>
                        <option value="1.1">1.1 ton</option>
                        <option value="1.2">1.2 ton</option>
                        <option value="1.3">1.3 ton</option>
                        <option value="1.4">1.4 ton</option>
                        <option value="1.5">1.5 ton</option>
                        <option value="1.6">1.6 ton</option>
                        <option value="1.7">1.7 ton</option>
                        <option value="1.8">1.8 ton</option>
                        <option value="1.9">1.9 ton</option>
                        <option value="2">2 ton</option>
                    </select>
                </div>
                <p className= "estimate-input-prompt">Do you have any TV's, computer monitors, tires, mattresses, box springs, oxygen tanks, or propane tanks?</p>
                <p>Click <Link to= "/Estimate#extra-costs">here</Link> or scroll down to add these extra cost items.</p>
            </section>
            
            {/* breakdown */}
            <br></br>
            <h3>Itemized Estimate</h3>
            <section className= "estimate-breakdown">
                <h3>Size</h3>
                <div className= "estimate-breakdown-section">
                    <p>{selectedDumpster} yard dumpster</p>
                    <p>${basePrice}</p>
                </div>
                <h3>Tonnage</h3>
                <div className= "estimate-breakdown-section">
                    <p>{tonnage} ton limit</p>
                    <p>$0</p>
                </div>
                <div className= "estimate-breakdown-section">
                    <p>{tonOver} ton over limit</p>
                    <p>${tonOver * tonnageFee}</p>
                </div>
                <h3>Days</h3>
                <div className= "estimate-breakdown-section">
                    <p>{daysNeeded} Day rental ({daysNeeded - initialDumpsterOptions.baseDays > 0 ? daysNeeded - initialDumpsterOptions.baseDays: 0} extra days.)</p>
                    <p>${daysCost}</p>
                </div>
                {extraCostRendered.length > 0 && (<h3>Extra Cost Items</h3>)}
                {extraCostRendered}


                { (daysNeeded <= initialDumpsterOptions.numberOfDaysForSalePrice) && (
            <>
                <h3>Discount</h3>
                <div id = "mini-discount" className= "estimate-breakdown-section">
                    <p>3 Day special for {selectedDumpster} yard dumpster</p>
                    <p>-${discount}</p>
                </div>

                
            </>)}
            <div className= "estimate-output" >
            <p>Total</p>
            <p>${totalPrice.toFixed(2)}</p>
        </div>
            </section>

        </section>
        <h3 id= "extra-costs">Extra Charge Items</h3>
        <div id= "extra-cost-container">
            {tiles}
        </div>
        
     </div>    
  )
}

export default Estimate;